import { render, staticRenderFns } from "./EntrepriseInfo.vue?vue&type=template&id=2a9034a8&scoped=true"
import script from "./EntrepriseInfo.vue?vue&type=script&lang=js"
export * from "./EntrepriseInfo.vue?vue&type=script&lang=js"
import style0 from "./EntrepriseInfo.vue?vue&type=style&index=0&id=2a9034a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9034a8",
  null
  
)

export default component.exports